/**
 * @Author: Li, Yu Jia
 * @Date: 2020-01-13 11:29:26
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2021-02-26 14:14:11
 * @Usage: userimage.actions.type
 */

import { createAction } from '@reduxjs/toolkit';

export const userImageActionType = {
  SLOGANLIST_INIT: 'SLOGANLIST_INIT',
  VERSELIST_INIT: 'VERSELIST_INIT',
  SENTIMENTLIST_INIT: 'SENTIMENTLIST_INIT',
  CATEGORIESINIT: 'CATEGORIESINIT',
  STOCKART_BY_CATEGORY: 'STOCKART_BY_CATEGORY',
  SAVEDART_COUNT_INIT: 'SAVEDART_COUNT_INIT',
  SAVEDART_LIST_INIT: 'SAVEDART_LIST_INIT',
  SHAREDART_INIT: 'SHAREDART_INIT',
  RECENTART_INIT: 'RECENTART_INIT',
  APPLYNOTICE_TOGGLE: 'APPLYNOTICE_TOGGLE',
  SET_USERIMAGE_DIMENSION: 'SET_USERIMAGE_DIMENSION',
  SET_USERIMAGE_CLONE: 'SET_USERIMAGE_CLONE',
  SET_APPLY_NOTICE_PROMPT: 'SET_APPLY_NOTICE_PROMPT',
  SET_SAVED_ART_THUMBNAIL: 'SET_SAVED_ART_THUMBNAIL',
  SET_APPLY_NOTICE_SCROLL: 'SET_APPLY_NOTICE_SCROLL',
  REMOVE_SAVEDART_FROM_RECENT: 'REMOVE_SAVEDART_FROM_RECENT',
  CLEAR_SHAREDART_DICT: 'CLEAR_SHAREDART_DICT',
};

export const sloganListInit = createAction(userImageActionType.SLOGANLIST_INIT);
export const verseListInit = createAction(userImageActionType.VERSELIST_INIT);
export const sentimentListInit = createAction(userImageActionType.SENTIMENTLIST_INIT);
export const categoriesInit = createAction(userImageActionType.CATEGORIESINIT);
export const stockArtByCategory = createAction(userImageActionType.STOCKART_BY_CATEGORY);
export const savedArtsCountInit = createAction(userImageActionType.SAVEDART_COUNT_INIT);
export const savedArtsListInit = createAction(userImageActionType.SAVEDART_LIST_INIT);
export const sharedArtsInit = createAction(userImageActionType.SHAREDART_INIT);
export const recentArtsInit = createAction(userImageActionType.RECENTART_INIT);
export const applyNoticeToggle = createAction(userImageActionType.APPLYNOTICE_TOGGLE);
export const setUserImageDimension = createAction(userImageActionType.SET_USERIMAGE_DIMENSION);
export const setUserImageClone = createAction(userImageActionType.SET_USERIMAGE_CLONE);
export const setApplyNoticePrompt = createAction(userImageActionType.SET_APPLY_NOTICE_PROMPT);
export const setSavedArtThumbnail = createAction(userImageActionType.SET_SAVED_ART_THUMBNAIL);
export const setApplyNoticeScroll = createAction(userImageActionType.SET_APPLY_NOTICE_SCROLL);
export const removeSavedArtFromRecent = createAction(userImageActionType.REMOVE_SAVEDART_FROM_RECENT);
export const clearSharedArtDict = createAction(userImageActionType.CLEAR_SHAREDART_DICT);
